import React from 'react'

import { TiPlus } from 'react-icons/ti'
import { styled } from 'styled-components'

const UploadFileBtn = styled.label<{ $disableLabel: boolean }>`
  background-color: ${(props) => (props.$disableLabel ? '#accad7' : '#BCDDEB')};
  padding: 10px 20px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  border-style: solid;
  border-width: ${(props) => (props.$disableLabel ? '0px' : '0.5px')};
  border-color: ${(props) => (props.$disableLabel ? 'transparent' : '#d4d1d1')};
  gap: 8px;
  cursor: ${(props) => (props.$disableLabel ? 'default' : 'pointer')};
`

const UploadAudioBtn = ({
  htmlFor,
  disableLabel,
  label,
}: {
  htmlFor: string
  disableLabel: boolean
  label: string
}) => {
  return (
    <UploadFileBtn htmlFor={htmlFor} $disableLabel={disableLabel}>
      <TiPlus fontSize={18} />
      {label}
    </UploadFileBtn>
  )
}

export default UploadAudioBtn
